$(function() {
	$('button#cancel').click(function() {
		window.history.back();
	});
	$('input.headline').first().focus();
	$('.delete').hover(function() {
		$(this).siblings('a').toggleClass('hover');
	});
	$('#courses .payment a').click(function(e) {
		var $this = $(this);
		var $parent = $('#courses .payment');
		if ($this.hasClass('disabled') || $parent.hasClass('disabled')) {
			e.preventDefault();
		}
		else {
			$parent.addClass('disabled');
			$this.addClass('disabled').html('Er a&eth; senda..');
		}
	});

	$('.paymentMethod__wrap', '#courses').each(function() {
		var $wrap = $(this);

		$wrap.on('click', function() {
			var $this = $(this),
				$container = $wrap.parents('.paymentMethod__container');
				$parent = $this.parents('.paymentMethods');

			if ($container.hasClass('paymentMethod--selected')) {
				$container.removeClass('paymentMethod--selected');
				$parent.removeClass('paymentMethods--selected')
			}
			else {
				if (!$parent.hasClass('paymentMethods--selected')) {
					$('.paymentMethods--selected', '#courses').removeClass('paymentMethods--selected');
				}
				$('.paymentMethod--selected', '#courses').removeClass('paymentMethod--selected');
				$container.addClass('paymentMethod--selected');
				$parent.addClass('paymentMethods--selected');
			}
		});
	});
});

var coursesAdmin = {};
if (window.courses) {
	coursesAdmin = courses.admin || {};
}
courses = (typeof courses !== 'undefined') ? courses : {};
courses.admin = coursesAdmin;
courses.allowedDates = [];
courses.exam = {
	init: function(allowedDates) {
		courses.allowedDates = allowedDates;
		$('#paid').click(function() {
			$('#fieldset_payerInfo').toggle();
		});
		courses.initDatePicker('.examDatepicker', 'dd.mm.yy');
	}
};
courses.initDatePicker = function(selector, dateFormat) {
	courses.dateFormat = dateFormat;
	var opts = {
		minDate: new Date(),
		dateFormat: dateFormat
	};
	var numAllowed = courses.allowedDates.length;
	if (numAllowed > 0) {
		opts['constrainInput'] = true;
		opts['beforeShowDay'] = courses.beforeShowDay;
		opts['minDate'] = $.datepicker.parseDate(dateFormat, courses.allowedDates[0]);
		opts['maxDate'] = $.datepicker.parseDate(dateFormat, courses.allowedDates[numAllowed-1]);
	}
	$(selector).datepicker(opts);
};
courses.beforeShowDay = function(dateObj) {
	var ret = false;
	var dateFormat = courses.dateFormat;
	var date = $.datepicker.formatDate(dateFormat, dateObj);
	for (var i = 0, c = courses.allowedDates.length; i < c; i++) {
		var d = courses.allowedDates[i];
		if (d == date) {
			ret = true;
			break;
		}
	}
	return [ret];
};

courses.timetable = {
	filter: {
		init: function() {
			$('.timetableFilter input', '#courses').change(function() {
				courses.timetable.filter.run();
			});
		},
		run: function() {
			$('.schedule .course', '#courses').addClass('hide');

			var classes = [];
			$('.timetableFilter .filterType input:checked', '#courses').each(function() {
				classes.push('type-' + $(this).val());
			});
			$('.timetableFilter .filterTeacher input:checked', '#courses').each(function() {
				classes.push('teacher-' + $(this).val());
			});
			$('.timetableFilter .filterCourse input:checked', '#courses').each(function() {
				classes.push('course-' + $(this).val());
			});

			if (classes.length > 0) {
				var selector = '.schedule .course.' + classes.join(', .room .course.');
				$(selector, '#courses').removeClass('hide');
			}
			else {
				$('.schedule .course', '#courses').removeClass('hide');
			}
		}
	}
};

courses.registration = {
	extra: {
		init: function () {
			$('#extra_collegeComplete').on('change', function () {
				if ($(this).val() === '1') {
					$('#elm_extra_collegeDegree').addClass('visible');
				}
				else {
					$('#elm_extra_collegeDegree').removeClass('visible');
				}
			}).trigger('change');

			$('#extra_collegeDegree').on('change', function () {
				if ($(this).val() === '3') {
					$('#elm_extra_collegeDegreeOther').addClass('visible');
				}
				else {
					$('#elm_extra_collegeDegreeOther').removeClass('visible');
				}
			}).trigger('change');
		}
	},
	company: {
		init: function () {
			$('#payerType-2').on('input', function () {
				courses.registration.company.doLookup();
			});

			$('#payerKennitala').on('input', function () {
				courses.registration.company.doLookup();
			})
		},
		doLookup: function () {
			var $input = $('#payerKennitala'),
				value = courses.registration.company.sanitizeKennitala($input.val());

			$input.val(value);
			console.log('value: ', value);

			if (courses.registration.company.isCompany() && value.length === 10) {
				courses.registration.company.lookup(value);
			}
		},
		sanitizeKennitala: function (input) {
			return input.replace(/\D+/g, "");
		},
		isCompany: function () {
			return $('#payerType-2').is(':checked');
		},
		lookup: function (kennitala) {
			$.ajax({
				'url': 'http://apis.is/company',
				'type': 'GET',
				'dataType': 'json',
				'data': {'socialnumber': kennitala},
				'success': function(response) {
					if (response && response.results && response.results.length === 1) {
						courses.registration.company.removeError();
						$('#payerName').val(response.results[0].name);
					}
					else {
						courses.registration.company.showError('Þessi kennitala fannst ekki í fyrirtækjaskrá');
					}
				}
			});
		},
		showError: function (errorMessage) {
			$('#elm_payerType').append('<div id="companyLookupError" class="message"><div class="warning">' + errorMessage + '</div></div>');
		},
		removeError: function () {
			$('#companyLookupError').remove();
		}
	}
};